export {default} from './MultipleChoice_component';



// WEBPACK FOOTER //
// ./components/qual/Table/TableHeader/TableHeaderCell/TableColumnFilter/FilterTypes/MultipleChoice/index.js